//
// Constantes de permisos disponibles
//

export class Permission {
    public static allConfiguration = 'all_configuration';
    public static readConfiguration = 'read_configuration';
    public static updateConfiguration = 'update_configuration';

    public static allTemplates = 'all_templates';
    public static readTemplates = 'read_templates';
    public static updateTemplates = 'update_templates';

    public static allUsers = 'all_users';
    public static readUsers = 'read_users';
    public static updateUsers = 'update_users';

    public static allCollaborativeArea = 'all_CollaborativeArea';
    public static readCollaborativeArea = 'read_CollaborativeArea';
    public static updateCollaborativeArea = 'update_CollaborativeArea';

    public static allAlgorithms = 'all_Algorithm';
    public static readAlgorithms = 'read_Algorithm';
    public static updateAlgorithms = 'update_Algorithm';
}
